/*
 * Title: Header/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Desktop main header navigation
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, { Fragment } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Popover, Transition } from "@headlessui/react";
import logo_black from "@assets/logo_black.png";
import menu_black from "@assets/menu_black.png";
import { useDispatch } from "react-redux";

interface Props { }

const Header: React.FC<Props | any> = (props) => {
  const { actions } = require("@redux/UserRedux");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(actions.setLogout(true));
    navigate('/logout');
  };

  return (
    <div
      className={`sticky -top-1 bg-[#FAF8F4] z-50 w-full hidden md:block`}>
      <div className="container mx-auto">
        <div className="flex justify-between items-center h-[80px] lg:space-x-10">
          <div className="flex items-center justify-start">
            <NavLink to="/accounts">
              <img
                className="h-[26px] w-[168px] object-contain"
                src={logo_black}
                alt="logo_black"
              />
            </NavLink>
            {/* <nav className="flex items-center justify-around w-full max-w-lg ml-10 gap-x-5">
              <NavLink
                style={({ isActive }) => ({
                  color: isActive ? "#f6104e" : null,
                })}
                to="/settings"
                className="text-[18px] hover:c-primary text-black font-medium text-nowrap flex items-center justify-center py-2.5 relative outline-none">
                Settings
              </NavLink>
              <NavLink
                style={({ isActive }) => ({
                  color: isActive ? "#f6104e" : null,
                })}
                to="/touchpoints"
                className="text-[18px] hover:c-primary text-black font-medium text-nowrap flex items-center justify-center py-2.5 relative outline-none">
                Touchpoints
              </NavLink>
              <a
                href="#"
                className="text-[18px] hover:c-primary text-black font-medium text-nowrap flex items-center justify-center py-2.5 relative outline-none">
                Dashboard
              </a>
              <a
                href="#"
                className="text-[18px] hover:c-primary text-black font-medium text-nowrap flex items-center justify-center py-2.5 relative outline-none">
                FAQ
              </a>
            </nav> */}
          </div>
          <div
            onClick={handleLogout}
            className="cursor-pointer pr-5 text-[16px] text-[#F6104E] text-center py-3 block font-semibold"
          >Log Out</div>
          {/* <div>
            <Popover.Group className="flex items-center justify-between gap-x-10">
              <Popover className="relative">
                <Popover.Button
                  className={
                    "flex items-center outline-none hover:opacity-80"
                  }>
                  <img
                    src={menu_black}
                    alt="Menu"
                    className="h-[16px] w-[20px] object-contain"
                  />
                </Popover.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1">
                  <Popover.Panel className="absolute right-0 z-50 mt-3 transform w-72">
                    <div className="relative bg-[#1D1D1D] px-3 py-4 rounded-lg shadow-black">
                      <p className="text-[#fff]/50 font-normal text-[16px] text-center uppercase my-3">
                        Account
                      </p>
                      <Popover.Button as="div">
                        <NavLink
                          to="/settings"
                          className="py-3 hover:bg-[#000]/20 text-white font-light block text-center text-[16px] cursor-pointer relative">
                          Settings
                        </NavLink>
                      </Popover.Button>
                      <div className="h-[1px] w-full bg-[#fff]/20" />
                      <Popover.Button as="div">
                        <NavLink
                          target="_blank"
                          to="/p/privacy-policy"
                          className="py-3 hover:bg-[#000]/20 text-white font-light block text-center text-[16px] cursor-pointer relative">
                          Privacy Policy
                        </NavLink>
                      </Popover.Button>
                      <div className="h-[1px] w-full bg-[#fff]/20" />
                      <Popover.Button as="div">
                        <NavLink
                          target="_blank"
                          to="/p/terms-conditions"
                          className="py-3 hover:bg-[#000]/20 text-white font-light block text-center text-[16px] cursor-pointer relative">
                          Terms & Conditions
                        </NavLink>
                      </Popover.Button>
                      <div className="h-[1px] w-full bg-[#fff]/20" />
                      <Popover.Button as="div">
                        <div
                          onClick={handleLogout}
                          className="cursor-pointer hover:bg-[#000]/20 text-[16px] text-red-500 text-center py-3 block font-light tracking-wider w-full"
                        //text="Log Out"
                        >Log Out</div>
                      </Popover.Button>
                      <p className="text-[white]/60 font-normal text-[10px] tracking-wider text-center mt-2">
                        Version: {process.env.REACT_APP_VERSION}
                      </p>
                    </div>
                  </Popover.Panel>
                </Transition>
              </Popover>
            </Popover.Group>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Header;
